var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331,
    height: 46,
    viewBox: "0 0 331 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.125 59.5535L187.812 56.6641L190.701 60.9774L187.812 65.29L192.125 62.4013L196.438 65.29L193.549 60.9774L196.438 56.6641L192.125 59.5535Z",
    fill: "url(#paint0_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.461 59.5535L134.148 56.6641L137.037 60.9774L134.148 65.29L138.461 62.4013L142.774 65.29L139.885 60.9774L142.774 56.6641L138.461 59.5535Z",
    fill: "url(#paint1_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8048 59.5535L80.4922 56.6641L83.3809 60.9774L80.4922 65.29L84.8048 62.4013L89.1182 65.29L86.2288 60.9774L89.1182 56.6641L84.8048 59.5535Z",
    fill: "url(#paint2_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1408 59.5535L26.8281 56.6641L29.7168 60.9774L26.8281 65.29L31.1408 62.4013L35.4541 65.29L32.5647 60.9774L35.4541 56.6641L31.1408 59.5535Z",
    fill: "url(#paint3_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.297 32.7253L160.984 29.8359L163.873 34.1493L160.984 38.4619L165.297 35.5732L169.61 38.4619L166.721 34.1493L169.61 29.8359L165.297 32.7253Z",
    fill: "url(#paint4_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.633 32.7253L107.32 29.8359L110.209 34.1493L107.32 38.4619L111.633 35.5732L115.946 38.4619L113.057 34.1493L115.946 29.8359L111.633 32.7253Z",
    fill: "url(#paint5_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9689 32.7253L53.6562 29.8359L56.545 34.1493L53.6562 38.4619L57.9689 35.5732L62.2822 38.4619L59.3928 34.1493L62.2822 29.8359L57.9689 32.7253Z",
    fill: "url(#paint6_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31264 32.7253L0 29.8359L2.88871 34.1493L0 38.4619L4.31264 35.5732L8.62597 38.4619L5.73656 34.1493L8.62597 29.8359L4.31264 32.7253Z",
    fill: "url(#paint7_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.125 5.8894L187.812 3L190.701 7.31333L187.812 11.626L192.125 8.73726L196.438 11.626L193.549 7.31333L196.438 3L192.125 5.8894Z",
    fill: "url(#paint8_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.461 5.8894L134.148 3L137.037 7.31333L134.148 11.626L138.461 8.73726L142.774 11.626L139.885 7.31333L142.774 3L138.461 5.8894Z",
    fill: "url(#paint9_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8048 5.8894L80.4922 3L83.3809 7.31333L80.4922 11.626L84.8048 8.73726L89.1182 11.626L86.2288 7.31333L89.1182 3L84.8048 5.8894Z",
    fill: "url(#paint10_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1408 5.8894L26.8281 3L29.7168 7.31333L26.8281 11.626L31.1408 8.73726L35.4541 11.626L32.5647 7.31333L35.4541 3L31.1408 5.8894Z",
    fill: "url(#paint11_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.313 60.3816L241 57.4922L243.889 61.8055L241 66.1182L245.313 63.2294L249.626 66.1182L246.737 61.8055L249.626 57.4922L245.313 60.3816Z",
    fill: "url(#paint12_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.805 33.5535L321.492 30.6641L324.381 34.9774L321.492 39.29L325.805 36.4013L330.118 39.29L327.229 34.9774L330.118 30.6641L325.805 33.5535Z",
    fill: "url(#paint13_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.141 33.5535L267.828 30.6641L270.717 34.9774L267.828 39.29L272.141 36.4013L276.454 39.29L273.565 34.9774L276.454 30.6641L272.141 33.5535Z",
    fill: "url(#paint14_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.313 6.72535L241 3.83594L243.889 8.14927L241 12.4619L245.313 9.5732L249.626 12.4619L246.737 8.14927L249.626 3.83594L245.313 6.72535Z",
    fill: "url(#paint15_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.804 5.69442L290.305 0L295.998 8.50068L290.305 17L298.804 11.3069L307.305 17L301.61 8.50068L307.305 0L298.804 5.69442Z",
    fill: "url(#paint16_linear_22474_5150)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.304 32.0294L211.305 26L217.333 35.0007L211.305 44L220.304 37.972L229.305 44L223.275 35.0007L229.305 26L220.304 32.0294Z",
    fill: "url(#paint17_linear_22474_5150)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22474_5150",
    x1: 487.805,
    y1: 86,
    x2: 0.304657,
    y2: -3.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336916,
    stopColor: "#FADFBA",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745772,
    stopColor: "#FDEDD6",
    stopOpacity: 0.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsOverlay);
export default __webpack_public_path__ + "static/media/StarsOverlay.8748edc356d6b4458e22b850fce6ec7c.svg";
export { ForwardRef as ReactComponent };